import { put } from 'helpers/api';
import { changePlan } from '../plans/actions';

export function updateUserPlans(user, userPlans) {
  return (dispatch, getState) => {
    saveUserPlans(user, userPlans, user.primaryPlanId);

    if (!userPlans.some(plan => plan.id === user.primaryPlanId)) {
      dispatch(changeUser(user, { primaryPlanId: null }));
    }

    for (const plan of getState().plans) {
      const planUsers = [...plan.users];
      const hasUser = planUsers.some(planUser => planUser.id === user.id);

      if (userPlans.some(userPlan => userPlan.id === plan.id)) {
        if (!hasUser) {
          dispatch(changePlan(plan, { users: [...planUsers, user] }));
        }
      } else if (hasUser) {
        dispatch(changePlan(plan, { users: planUsers.filter(planUser => planUser.id !== user.id) }));
      }
    }
  };
}

export function updateUserPrimaryPlanId(user, primaryPlanId) {
  return (dispatch, getState) => {
    const plans = getState().plans.filter(plan => plan.users.some(planUser => planUser.id === user.id));
    saveUserPlans(user, plans, primaryPlanId);
    dispatch(changeUser(user, { primaryPlanId }));
  };
}

export const CHANGE_USER = 'CHANGE_USER';
export function changeUser(user, changes) {
  return { type: CHANGE_USER, user, changes };
}

function saveUserPlans(user, plans, primaryPlanId) {
  return put(user.path, {
    user: {
      commissionPlansUsersAttributes: plans.map(plan => ({
        commissionPlanId: plan.id,
        primary: plan.id === primaryPlanId,
      })),
    },
  });
}
